import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { LocalizationModule } from '@sb/library/localization';
import { UtilityModule } from '@sb/library/utility';
import { AttachmentComponent } from './attachment.component';

@NgModule({
    declarations: [
        AttachmentComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        MatDialogModule,
        ButtonModule,
        MatDividerModule,
        MatExpansionModule,
        UtilityModule,
        IconModule,
        LocalizationModule
    ],
    exports: [
        AttachmentComponent
    ]
})
export class AttachmentModule { }
